// extracted by mini-css-extract-plugin
export var container = "TextMeUpdates_container__FFotn";
export var disclaimer = "TextMeUpdates_disclaimer__E6o7p";